import { IMoneyReceipt } from 'src/Types/module/common/commonTypes';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Visibility } from '@mui/icons-material';
import DeleteConfirmation from 'src/Utils/DeleteConfirmation';

type IProps = {
  sInvoice: IMoneyReceipt;
  allInvoices: IMoneyReceipt[];
  setAllInvoices: any;
  index: number;
};
const OldMoneyReceiptRow = ({ sInvoice: invoiceData, index }: IProps) => {
  const theme = useTheme();

  return (
    <TableRow hover>
      <TableCell>{index + 1}</TableCell>
      <TableCell>
        {moment(invoiceData.created_at).format('DD-MMM-YYYY')}
      </TableCell>
      <TableCell>{invoiceData.money_receipt_no}</TableCell>
      <TableCell>{invoiceData.user_member_company_name}</TableCell>

      <TableCell>{invoiceData.total_collected_amount}</TableCell>
      <TableCell>
        <Tooltip title='View' arrow>
          <Link to={`${invoiceData.id}`}>
            <IconButton
              sx={{
                '&:hover': {
                  background: theme.colors.primary.lighter,
                },
                color: theme.palette.primary.main,
              }}
              color='inherit'
              size='small'
            >
              <Visibility fontSize='small' />
            </IconButton>
          </Link>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default OldMoneyReceiptRow;
